import { PageMeta } from '../components/seo/PageMeta'
import { SupportForm } from '../components/SupportForm/SupportForm'
import { pageMeta } from '../lib/seo'
import { hubSupportSchema } from '../lib/schema'

export default function HubSupport() {
  return (
    <>
      <PageMeta
        title={pageMeta.hubSupport.title}
        description={pageMeta.hubSupport.description}
        canonical={pageMeta.hubSupport.canonical}
        schema={hubSupportSchema}
        noindex
      />
      <main className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-display font-bold text-3xl uppercase text-white mb-2">
            HUB Support
          </h1>
          <p className="font-body text-cream-dim mb-8">
            Report an issue or request an enhancement for the HUB EHR platform.
          </p>
          <SupportForm />
        </div>
      </main>
    </>
  )
}
